import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid.jsx';
import NewCommonSelect from '../../../component/common/selectBox/NewCommonSelect.jsx';

const BdTongmFieldin = () => {

    const [searchParams, setSearchParams] = useState({
        searchCheck1: '',
        searchGrdc: '',
        searchLoca: '',
        searchGubun: 'ptmiidno',
        searchType: 'A',
        searchYear: new Date().getFullYear(),
    });

    const today = new Date();
    const currentYear = today.getFullYear();

    const searchOptions = {
        A: {
            label: '환자,기관',
            options: [
                { value: 'idno', label: '등록번호' },
                { value: 'name', label: '성명' },
                { value: 'brtd', label: '나이' },
                { value: 'sexx', label: '성별' },
                { value: 'iukd', label: '보험유형' },
                { value: 'hscd', label: '요양기관기호' },
                { value: 'drlc', label: '면허번호' }
            ]
        },
        B: {
            label: '내원정보',
            options: [
                { value: 'akdt', label: '발병일자' },
                { value: 'aktm', label: '발병시간' },
                { value: 'dgkd', label: '내원사유(질병여부)' },
                { value: 'arcf', label: '내원사유(의도성여부)' },
                { value: 'arcs', label: '내원사유(손상기전)' },
                { value: 'indt', label: '내원일자' },
                { value: 'intm', label: '내원시간' },
                { value: 'inrt', label: '내원경로' },
                { value: 'inmn', label: '내원수단' }
            ]
        },
        C: {
            label: '초기평가',
            options: [
                { value: 'mnsy', label: '주증상' },
                { value: 'etsy', label: '기타증상' },
                { value: 'emsy', label: '응급증상 해당여부' },
                { value: 'resp', label: '내원시 반응' },
                { value: 'hibp', label: '수축기혈압' },
                { value: 'lobp', label: '이완기혈압' },
                { value: 'puls', label: '맥박수' },
                { value: 'brth', label: '호흡수' },
                { value: 'bdht', label: '체온' }
            ]
        },
        D: {
            label: '응급진료',
            options: [
                { value: 'emrt', label: '응급진료 결과' },
                { value: 'dept', label: '주진료과' },
                { value: 'otdt', label: '퇴실일자' },
                { value: 'ottm', label: '퇴실시간' },
                { value: 'dgot', label: '퇴실시 진단내역' }
            ]
        },
        E: {
            label: '최종진료',
            options: [
                { value: 'dcrt', label: '입원후 결과' },
                { value: 'dcdt', label: '퇴원일자' },
                { value: 'oppt', label: '수술내역' },
                { value: 'dgdc', label: '퇴원시 최종 진단내역' }
            ]
        }
    };

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        if (name === 'searchType') {
            if (checked) {
                const selectedOption = searchOptions[value].options[0].value;
                setSearchParams(prev => ({
                    ...prev,
                    searchType: value,
                    searchGubun: 'ptmi' + selectedOption
                }));
            }
        } else if (name.startsWith('search') && name.endsWith('Cls')) {
            setSearchParams(prev => ({
                ...prev,
                searchGubun: 'ptmi' + value
            }));
        } else {
            setSearchParams(prev => ({
                ...prev,
                [name]: type === 'checkbox' ? (checked ? '1' : '') : value
            }));
        }
    };

    const dataHead = ['의료기관명', '종별', '합계', '(%)', '1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'];
    const dataColumn = ['EMNAME', 'EMTYPE', 'TOT', '', 'TT1', 'TT2', 'TT3', 'TT4', 'TT5', 'TT6', 'TT7', 'TT8', 'TT9', 'TT10', 'TT11', 'TT12'];
    const apiCall = '/ptmiapi/monitoring/bdtongmfieldin_search.do';
    const apiCntCall = '';
    const searchParamsAdditional = {};
    const excelFileName = "항목별 월 입력률";
    const excelHead = [];
    const mergeConfig = [{ key: 'EMNAME', row: null }, { key: 'EMTYPE', row: 2 }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    return (
        <Main>
            <div className='com-search'>
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                        <col width="10%" />
                        <col width="20%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <NewCommonSelect
                                hospitalTF={false}
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                            />
                            <th>내원일시</th>
                            <td>
                                <select
                                    id="searchYear"
                                    name="searchYear"
                                    value={searchParams.searchYear}
                                    onChange={handleInputChange}
                                >
                                    {Array.from({ length: 11 }, (_, i) => {
                                        const year = (currentYear - i).toString()
                                        return (
                                            <option key={year} value={year}>
                                                {year} 년
                                            </option>
                                        );
                                    })}
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <th>항목</th>
                            <td colSpan={5}>
                                <span className='flex justify-start'>
                                    <input type="hidden" id="searchGubun" name="searchGubun" value={searchParams.searchGubun} />
                                    <div className='flex items-center'>
                                        {Object.entries(searchOptions).map(([key, { label }]) => (
                                            <div key={key} className='mr-3'>
                                                <input
                                                    type="radio"
                                                    id={`searchType${key}`}
                                                    name="searchType"
                                                    checked={searchParams.searchType === key}
                                                    value={key}
                                                    onChange={handleInputChange}
                                                />
                                                <label htmlFor={`searchType${key}`}>{label}</label>
                                            </div>
                                        ))}
                                    </div>

                                    {Object.entries(searchOptions).map(([key, { options }]) => (
                                        <div key={key} id={`div${key}`}
                                            className={searchParams.searchType === key ? 'block' : 'hidden'}
                                        >
                                            <select className='w-40'
                                                id={`search${key}Cls`}
                                                name={`search${key}Cls`}
                                                onChange={handleInputChange}
                                                value={searchParams.searchGubun.replace('ptmi', '')}
                                            >
                                                {options.map(({ value, label }) => (
                                                    <option key={value} value={value}>
                                                        {label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                    ))}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <td colSpan="4">
                                <div>
                                    <span>
                                        <input type="checkbox" id="searchCheck1" name="searchCheck1" checked={searchParams.searchCheck1 === '1'} onChange={handleInputChange} />
                                        <label htmlFor="searchCheck1">진료외 방문 (챠트복사, 경유를 위한 접수) 제외</label>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
            <NewDataGrid
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                mergeConfig={mergeConfig}
            />
        </Main >
    )
}

export default BdTongmFieldin;